import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {BookingStatus, InvoiceEmail, InvoiceEmailStatus, InvoiceGet} from '../../../../generated/sales-terminal-client';
import {ValidationService} from '../../../../services/validation/validation.service';
import {InvoiceService} from '../../../../services/invoice/invoice.service';
import {SnackService} from '../../../../services/snack/snack.service';
import {TranslateService} from '@ngx-translate/core';
import {ViewService} from '../../../../services/view/view.service';
import {Observable} from 'rxjs';
import {UtilService} from "../../../../services/util/util.service";
import {TextInputType} from '../../../../components/forms/text-input/text-input.component';

export interface EmailDialogData {
  invoiceUuid: string;
  prefilledAddress: string;
  isLinkPayValid?: boolean;
  bookingStatus: BookingStatus;
}

@Component({
  selector: 'app-email-modal',
  templateUrl: './email-modal.component.html',
  styleUrls: ['./email-modal.component.scss'],
})
export class EmailModalComponent implements OnInit {
  invoice: InvoiceGet;
  sentEmails: InvoiceEmail[];
  emails: string;
  emailsOrig: string;
  emailsArray: string[];
  isLinkPayValid: boolean;
  bookingStatus: BookingStatus;

  constructor(
    public dialogRef: MatDialogRef<EmailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EmailDialogData,
    private dialog: MatDialog,
    private invoiceService: InvoiceService,
    private snackService: SnackService,
    private translateService: TranslateService,
    public viewService: ViewService,
    public utilService: UtilService
  ) { }

  ngOnInit(): void {
    this.invoiceService.getInvoice(this.data.invoiceUuid).subscribe(resp => this.invoice = resp);
    this.invoiceService.getSentInvoiceEmails(this.data.invoiceUuid).subscribe(resp => this.sentEmails = resp.reverse());
    this.isLinkPayValid = this.data.isLinkPayValid;
    this.bookingStatus = this.data.bookingStatus;
    if (this.data.prefilledAddress) {
      this.emails = this.data.prefilledAddress;
    }
  }

  get isValid(): boolean {
    if (!this.emails?.length) {
      return false;
    }
    this.emailsArray = this.emails.split(',').map(email => email.trim());
    for (const email of this.emailsArray) {
      if (!ValidationService.validateEmail(email)) {
        return false;
      }
    }
    return true;
  }

  isLinkPayEmailValid(): boolean {
    return this.isValid && this.emailsArray.length === 1;
  }

  sendEmail(): void {
    if (!this.isValid) {
      return;
    }
    this.processSendEmailObservable(this.invoiceService.sendEmails(this.invoice.uuid, this.emailsArray));
  }

  sendLinkPayEmail(): void {
    if (!this.isLinkPayEmailValid()) {
      return;
    }
    this.processSendEmailObservable(this.invoiceService.sendLinkpayEmails(this.invoice.uuid, this.emailsArray));
  }

  processSendEmailObservable(obs: Observable<any>): void {
    obs.subscribe((resp) => {
      this.snackService.showSuccess(this.translateService.instant(resp.message));
      this.dialogRef.close();
    });
  }

  isProcessed(email: InvoiceEmail): boolean {
    return email.status === InvoiceEmailStatus.Processed;
  }

  isBookingReleased(): boolean {
    return this.bookingStatus === BookingStatus.Released;
  }

  isBookingActive(): boolean {
    return this.bookingStatus === BookingStatus.Active;
  }

  isBookingCancelledOrScrapped(): boolean {
    return this.bookingStatus === BookingStatus.Cancelled || this.bookingStatus === BookingStatus.Scrap;
  }

  protected readonly TextInputType = TextInputType;
}
